// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export type {
  CustomValidationFunction,
  ICustomJsonPathMetadata,
  ICustomPropertyInheritance,
  IJsonPathMetadata,
  IJsonPathMetadataResolverOptions,
  IJsonPathsMetadata,
  INonCustomJsonPathMetadata,
  IOriginalValueOptions,
  IProjectConfigurationFileSpecification,
  IPropertiesInheritance,
  IPropertyInheritance,
  IPropertyInheritanceDefaults,
  InheritanceType,
  PathResolutionMethod,
  PropertyInheritanceCustomFunction
} from '@rushstack/heft-config-file';
